import React,{ useEffect,useState,Suspense,lazy }  from 'react'
import { BrowserRouter, Routes, Route} from 'react-router-dom'
import { Outlet } from 'react-router-dom';
import  NavBar  from './component/NavBar'
import './App.css'
import { Box } from '@mui/material';
import { CRMForm } from './Pages/CRMForm'
import { CRMForm2 } from './Pages/CRMForm2'
import { CRMEdit } from './Pages/CRMEdit'
import  Login  from './Pages/Login';
import { Home }  from './Pages/Home';
import { ReportCus }  from './Pages/ReportCus';
import { Expire }  from './Pages/Expire';
import {ListCustomer} from './Pages/ListCustomer';
import { styled } from '@mui/material/styles'


function App() {
  const [isLogged, setisLogged] = useState(false);
  useEffect(() => {
      const token = localStorage.getItem('token')
      fetch('http://27.254.66.164:5000/Author',{
      method: 'POST',
      withCredentials: true,
      mode: 'cors',
      headers: {
          'Authorization': 'Bearer '+token,
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
      },
  })
  .then(response => response.json())
  .then(data => {
          if (data.status === 'ok'){
            setisLogged(true);
          } else {
            setisLogged(false);
          }
      });
  }, [])

  const DashboardLayoutRoot = styled('div')(({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    maxWidth: '100%',
    paddingTop: 64,
   
  }));
  const SidebarLayout = () => (
      <>  
          <NavBar/> 
          <Outlet />
      </>
    );
    return (
      
      <>
      {!isLogged ? (
       
        <Box
              sx={{
                display: 'flex',
                flex: '1 1 auto',
                flexDirection: 'column',
                width: '100%'
              }}
            >
              <BrowserRouter basename={'/ec-crm'}>
                  <Routes>
                    <Route>
                      <Route path="/" element={<Login/>} /> 
                      <Route path="/Form" element={<Expire/>} />
                      <Route path="/Customer" element={<Expire/>} />
                      <Route path="/Login" element={<Login/>} />
                      <Route path="/ReportCus" element={<Expire/>} />
                      <Route path="/ListCustomer" element={<Expire/>} />
                      <Route path="/Edit" element={<Expire/>} />
                    </Route>
                  </Routes>
              </BrowserRouter>
        </Box>
      ) : (
        <DashboardLayoutRoot>
        <Box
              sx={{
                display: 'flex',
                flex: '1 1 auto',
                flexDirection: 'column',
                width: '100%'
              }}
            >
              <BrowserRouter basename={'/ec-crm'}>
                  <Routes>
                    <Route element={<SidebarLayout/>}>
                      <Route path="/" element={<Home/>} /> 
                      <Route path="/Customer" element={<CRMForm/>} />
                      <Route path="/Form" element={<CRMForm2/>} />
                      <Route path="/Login" element={<Login/>} />
                      <Route path="/ReportCus" element={<ReportCus/>} />
                      <Route path="/ListCustomer" element={<ListCustomer/>} />
                      <Route path="/Edit" element={<CRMEdit/>} />
                    </Route>
                  </Routes>
              </BrowserRouter>
        </Box>
      </DashboardLayoutRoot>

      )}
      </>
    )
}
export default App;